import { render, staticRenderFns } from "./shopify_hook.vue?vue&type=template&id=71c4607e&scoped=true&"
import script from "./shopify_hook.vue?vue&type=script&lang=js&"
export * from "./shopify_hook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c4607e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71c4607e')) {
      api.createRecord('71c4607e', component.options)
    } else {
      api.reload('71c4607e', component.options)
    }
    module.hot.accept("./shopify_hook.vue?vue&type=template&id=71c4607e&scoped=true&", function () {
      api.rerender('71c4607e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/shopify/location/tabs/shopify_hook.vue"
export default component.exports